import {
  DriverUpdateService,
} from "../../../types/common.interface";
import customAxios from "../../customAxios";
import {
  DRIVER_UPDATE_SERVICE,
} from "../../routes";

const driverUpdateService = async ({
  serviceId,
  studentFirstName,
  studentLastName,
  price,
  parent,
  school,
  startService
}: DriverUpdateService) => {
  let body: any = {
    studentFirstName,
    studentLastName,
    price,
    parent,
    school,
    startService
  };

  console.log({body})

  // if (isChecked !== undefined) {
  //   body = { ...body, isChecked };
  // }
  // if (statusInService !== undefined) {
  //   body = { ...body, statusInService };
  // }
  // if (description !== "") {
  //   body = { ...body, description };
  // }

  try {
    return (await customAxios.put(DRIVER_UPDATE_SERVICE + "/" + serviceId, body))
      .data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER: error });
    return false;
  }
};

export default driverUpdateService;
